import { z } from 'zod';
import { patchOf } from './patch';

const dt = z.iso.datetime({ offset: true });
const optId = z
  .uuid()
  .nullable()
  .optional()
  .transform((v) => v ?? null);

/** Registro manual: início e fim, ou início e duração. */
export const timeEntryInput = z
  .object({
    taskId: optId,
    /** Material da demanda (o relógio por tipo de material). */
    taskItemId: optId,
    projectId: optId,
    startedAt: dt,
    endedAt: dt.nullable().optional(),
    durationMinutes: z
      .number()
      .int()
      .min(1)
      .max(24 * 60)
      .optional(),
    description: z.string().trim().max(1000).default(''),
    billable: z.boolean().default(true),
  })
  .refine((v) => v.endedAt || v.durationMinutes, {
    message: 'Informe o fim ou a duração',
    path: ['durationMinutes'],
  });
export type TimeEntryInput = z.input<typeof timeEntryInput>;

export const timeEntryPatch = patchOf(
  z.object({
    taskId: optId,
    projectId: optId,
    startedAt: dt,
    durationMinutes: z
      .number()
      .int()
      .min(1)
      .max(24 * 60),
    description: z.string().trim().max(1000),
    billable: z.boolean(),
  }),
);

export const timerStartInput = z.object({
  taskId: optId,
  taskItemId: optId,
  projectId: optId,
  description: z.string().trim().max(1000).default(''),
});

export const timeEntryDto = z.object({
  id: z.uuid(),
  user: z.object({ id: z.uuid(), name: z.string() }),
  task: z.object({ id: z.uuid(), title: z.string() }).nullable(),
  material: z.object({ id: z.uuid(), name: z.string() }).nullable(),
  project: z.object({ id: z.uuid(), name: z.string() }).nullable(),
  client: z.object({ id: z.uuid(), name: z.string() }).nullable(),
  startedAt: z.string(),
  endedAt: z.string().nullable(),
  durationMinutes: z.number(),
  description: z.string(),
  billable: z.boolean(),
  source: z.enum(['manual', 'timer']),
  running: z.boolean(),
});
export type TimeEntryDto = z.infer<typeof timeEntryDto>;

export const timeListQuery = z.object({
  from: dt.optional(),
  to: dt.optional(),
  userId: z.uuid().optional(),
  projectId: z.uuid().optional(),
  taskId: z.uuid().optional(),
});

/** "2h 15min" */
export function formatMinutes(min: number): string {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h ? (m ? `${h}h ${m}min` : `${h}h`) : `${m}min`;
}
